import { Record } from 'immutable'

export interface ITeamMember {
  readonly name: number
  readonly userId: string
}

const TeamMemberRecord = Record({
  name: '',
  userId: '',
})

export class TeamMember extends TeamMemberRecord implements ITeamMember {
  public static fromJS(initialState?: Partial<ITeamMember>) {
    return new TeamMember(initialState)
  }

  public readonly name: number
  public readonly userId: string

  constructor(props?: Partial<TeamMember>) {
    props ? super(props) : super()
  }
}
